import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var CardSection = function CardSection(_ref) {
  var children = _ref.children,
    side = _ref.side,
    overlay = _ref.overlay,
    background = _ref.background,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('component', side && "".concat(side, "Side"), className),
    style: {
      background: side === 'top' ? background : null
    },
    "data-t-id": "cards-CardSection"
  }, overlay && /*#__PURE__*/React.createElement("div", {
    className: cn('overlay')
  }, overlay), /*#__PURE__*/React.createElement("div", {
    className: cn('content')
  }, children));
};
CardSection.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  overlay: PropTypes.node,
  /**
   * В будущем может быть расширено на left, right, hMiddle (для горизонтальных карточек)
   */
  side: PropTypes.oneOf(['top', 'bottom', 'vMiddle']),
  className: PropTypes.string,
  background: PropTypes.string
} : {};